import PurpleWarning from '@/common/assets/icons/purpleWarningIcon.svg?react';
import { Box, Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';
import { useNavigate } from 'react-router-dom';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal closeModal={closeModal} open={open}>
    <AlreadyRegisteredModal closeModal={closeModal} />
  </MainModal>
);

const AlreadyRegisteredModal = ({
  closeModal,
}: {
  closeModal: MainModalProps['closeModal'];
}) => {
  const navigate = useNavigate();
  const onSubmit = () => {
    closeModal();
    navigate(AUTH_LINKS.login);
  };
  return (
    <Box>
      <Center mb="20px">
        <PurpleWarning />
      </Center>
      <Typography mb="20px">
        شما قبلا تقاضای همکاری خود را ثبت کرده‌اید و درخواست شما تایید شده است؛
        می‌توانید به عنوان کارشناس وارد اپلیکیشن شوید .
      </Typography>
      <Button mb="20px" onClick={() => onSubmit()} fullWidth>
        ورود به اپلیکیشن
      </Button>
    </Box>
  );
};
